var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Themes, ThemeVariants } from "../../../theme/_Types";
import ClaudeBrandLogo from "../../../assets/images/themes/claude/logo-brand.svg";
import ClaudeContrastLogo from "../../../assets/images/themes/claude/logo-contrast.svg";
import ClaudeShadedLogo from "../../../assets/images/themes/claude/logo-shaded.svg";
import VWPFSBrandLogo from "../../../assets/images/themes/vwpfs/logo-brand.svg";
import VWPFSContrastLogo from "../../../assets/images/themes/vwpfs/logo-contrast.svg";
import VWPFSShadedLogo from "../../../assets/images/themes/vwpfs/logo-shaded.svg";
import VWBrandLogo from "../../../assets/images/themes/vw/logo-brand.svg";
import VWContrastLogo from "../../../assets/images/themes/vw/logo-contrast.svg";
import VWShadedLogo from "../../../assets/images/themes/vw/logo-shaded.svg";
import AudiBrandLogo from "../../../assets/images/themes/audi/logo-brand.svg";
import AudiContrastLogo from "../../../assets/images/themes/audi/logo-contrast.svg";
import AudiShadedLogo from "../../../assets/images/themes/audi/logo-shaded.svg";
import SkodaBrandLogo from "../../../assets/images/themes/skoda/logo-brand.svg";
import SkodaContrastLogo from "../../../assets/images/themes/skoda/logo-contrast.svg";
import SkodaShadedLogo from "../../../assets/images/themes/skoda/logo-shaded.svg";
import SeatBrandLogo from "../../../assets/images/themes/seat/logo-brand.svg";
import SeatContrastLogo from "../../../assets/images/themes/seat/logo-contrast.svg";
import SeatShadedLogo from "../../../assets/images/themes/seat/logo-shaded.svg";
import DutchLeaseBrandLogo from "../../../assets/images/themes/dutchlease/logo-brand.svg";
import DutchLeaseContrastLogo from "../../../assets/images/themes/dutchlease/logo-contrast.svg";
import DutchLeaseShadedLogo from "../../../assets/images/themes/dutchlease/logo-shaded.svg";
import XLLeaseBrandLogo from "../../../assets/images/themes/xllease/logo-brand.svg";
import XLLeaseContrastLogo from "../../../assets/images/themes/xllease/logo-contrast.svg";
import XLLeaseShadedLogo from "../../../assets/images/themes/xllease/logo-shaded.svg";
import ManBrandLogo from "../../../assets/images/themes/man/logo-brand.svg";
import ManContrastLogo from "../../../assets/images/themes/man/logo-contrast.svg";
import ManShadedLogo from "../../../assets/images/themes/man/logo-shaded.svg";
import PolitieBrandLogo from "../../../assets/images/themes/politie/logo-brand.svg";
import PolitieContrastLogo from "../../../assets/images/themes/politie/logo-contrast.svg";
import PolitieShadedLogo from "../../../assets/images/themes/politie/logo-shaded.svg";
import XLEasyBrandLogo from "../../../assets/images/themes/xleasy/logo-brand.svg";
import XLEasyContrastLogo from "../../../assets/images/themes/xleasy/logo-contrast.svg";
import XLEasyShadedLogo from "../../../assets/images/themes/xleasy/logo-shaded.svg";
/**
 *
 * @param props
 */
export var Logo = function (props) {
    var getLogo = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        switch (props.theme) {
            case Themes.VWPFS:
                return _a = {},
                    _a[ThemeVariants.BRAND] = VWPFSBrandLogo,
                    _a[ThemeVariants.CONTRAST] = VWPFSContrastLogo,
                    _a[ThemeVariants.SHADED] = VWPFSShadedLogo,
                    _a;
            case Themes.VW:
                return _b = {},
                    _b[ThemeVariants.BRAND] = VWBrandLogo,
                    _b[ThemeVariants.CONTRAST] = VWContrastLogo,
                    _b[ThemeVariants.SHADED] = VWShadedLogo,
                    _b;
            case Themes.AUDI:
                return _c = {},
                    _c[ThemeVariants.BRAND] = AudiBrandLogo,
                    _c[ThemeVariants.CONTRAST] = AudiContrastLogo,
                    _c[ThemeVariants.SHADED] = AudiShadedLogo,
                    _c;
            case Themes.SKODA:
                return _d = {},
                    _d[ThemeVariants.BRAND] = SkodaBrandLogo,
                    _d[ThemeVariants.CONTRAST] = SkodaContrastLogo,
                    _d[ThemeVariants.SHADED] = SkodaShadedLogo,
                    _d;
            case Themes.SEAT:
                return _e = {},
                    _e[ThemeVariants.BRAND] = SeatBrandLogo,
                    _e[ThemeVariants.CONTRAST] = SeatContrastLogo,
                    _e[ThemeVariants.SHADED] = SeatShadedLogo,
                    _e;
            case Themes.DUTCHLEASE:
                return _f = {},
                    _f[ThemeVariants.BRAND] = DutchLeaseBrandLogo,
                    _f[ThemeVariants.CONTRAST] = DutchLeaseContrastLogo,
                    _f[ThemeVariants.SHADED] = DutchLeaseShadedLogo,
                    _f;
            case Themes.XLLEASE:
                return _g = {},
                    _g[ThemeVariants.BRAND] = XLLeaseBrandLogo,
                    _g[ThemeVariants.CONTRAST] = XLLeaseContrastLogo,
                    _g[ThemeVariants.SHADED] = XLLeaseShadedLogo,
                    _g;
            case Themes.XLEASY:
                return _h = {},
                    _h[ThemeVariants.BRAND] = XLEasyBrandLogo,
                    _h[ThemeVariants.CONTRAST] = XLEasyContrastLogo,
                    _h[ThemeVariants.SHADED] = XLEasyShadedLogo,
                    _h;
            case Themes.MAN:
                return _j = {},
                    _j[ThemeVariants.BRAND] = ManBrandLogo,
                    _j[ThemeVariants.CONTRAST] = ManContrastLogo,
                    _j[ThemeVariants.SHADED] = ManShadedLogo,
                    _j;
            case Themes.POLITIE:
                return _k = {},
                    _k[ThemeVariants.BRAND] = PolitieBrandLogo,
                    _k[ThemeVariants.CONTRAST] = PolitieContrastLogo,
                    _k[ThemeVariants.SHADED] = PolitieShadedLogo,
                    _k;
            default:
                return _l = {},
                    _l[ThemeVariants.BRAND] = ClaudeBrandLogo,
                    _l[ThemeVariants.CONTRAST] = ClaudeContrastLogo,
                    _l[ThemeVariants.SHADED] = ClaudeShadedLogo,
                    _l;
        }
    };
    var logos = getLogo();
    return (React.createElement("img", { src: props.img ? props.img : logos[props.variant], alt: props.theme, style: __assign({}, props.style), className: props.className }));
};
